/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  NoticeService,
  type Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto,
} from '../../services/wealthlane-award-services';

const usePostGrantAcceptanceTemplate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(NoticeService.postApiAwardApiNoticesManage(payload));

      // if (payload.id) {
      //   return await handleRequest(NoticeService.putApiAwardApiNotices(payload.id, payload));
      // } else {
      //   return await handleRequest(NoticeService.postApiAwardApiNotices(payload));
      // }
    },
    {
      onSuccess: async (
        response: Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto | undefined
      ) => {
        if (response) {
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Grant Acceptance Template ${id ? 'edited' : 'created'}.`}
            />
          );
          await queryClient.invalidateQueries('getGrantAcceptanceTemplateList');
        }
      },
      onError: (err) => {
        console.log('error', err);
        closeModal();
      },
    }
  );
};

export default usePostGrantAcceptanceTemplate;
